import { getknowUsMoreAction } from "store/Home";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Input } from "reactstrap";
import { Search } from "react-feather";
import { Link } from "react-router-dom";
import { ChevronLeft } from "react-feather";
import bookmark from "views/job-listing/img/bookmark.svg";
import logo from "views/ilearn/img/icici.png";
import filter from "views/job-listing/img/filter.png";
import TrendingJobs1 from "views/home/img/courses/course1.png";
import { connect } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

// import Swiper core and required modules
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper/core";
import banner1 from "views/ilearn/img/banner.png";

// install Swiper modules
SwiperCore.use([EffectFade, Navigation, Pagination]);
class KnowUsMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      jobs: [],
      filter: false,
    };
  }
//   async componentDidMount() {
//     let response = await this.props.getknowUsMoreAction();
//   }
  addDefaultSrc(ev) {
    ev.target.src = banner1;
  }
  render() {
    return (
        <>
          <Swiper
            spaceBetween={30}
            effect={"fade"}
            navigation={false}
            pagination={{
              clickable: true,
            }}
            className="mySwiper"
          >
            {this.props.knowusmore && this.props.knowusmore.Data
            .slice(0,3).map((course)=>(
            <SwiperSlide className="relative ">
              <img
               onError={this.addDefaultSrc}
               src={
                process.env.REACT_APP_IMAGE_BASE_MG +
                "/" + course.p_cover_img_path}
                className="w-full maxh-396px object-fill"
                alt="banner-img "
              />
    
              <div className="inside-listing absolute w-1/3 text-left">
                <h1 className="text-black font-semibold ">{course.p_title || 'The Course'}</h1>
                <p className="text262626 fsize18 text-left">
                {course.p_short_description ||
                        'this is short description' }
                </p>
              </div>
            </SwiperSlide>
    ))}
          </Swiper>
        </>
      );
  }

}

const mapStateToProps = (state) => {
  return {
    knowusmore: state.Home.home.KNOWUSMORE,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getknowUsMoreAction: async () => await dispatch(getknowUsMoreAction()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(KnowUsMore);
